import { Component } from '@angular/core';
import { EffectivePolicySettingEnum } from '../../../services/infra/store/model/effectivePolicySetting.model';
import { PrivilegedIdentitiesSectionComponent } from '../privileged-identities-section.component';

@Component({
  selector: 'app-privileged-identities-agent-section',
  templateUrl: '../privileged-identities-section.component.html',
  styleUrls: ['../privileged-identities-section.component.scss'],
})
export class PrivilegedIdentitiesAgentComponent extends PrivilegedIdentitiesSectionComponent {
  constructor() {
    super();
    this.title = 'policyPage.config.generalSettingsContent.allowedNumOfPrivilegedIdentitiesToAgent';
    this.description = 'policyPage.config.generalSettingsContent.allowedNumOfPrivilegedIdentitiesToAgentDesc';
    this.effectivePolicySetting = EffectivePolicySettingEnum.allowedNumOfPrivilegedIdentitiesToAgent;
    this.formControlName = 'allowedNumOfPrivilegedIdentitiesToAgent';
  }
}
